import { render, staticRenderFns } from "./SetBaggagePrices.vue?vue&type=template&id=be328918&scoped=true"
import script from "./SetBaggagePrices.vue?vue&type=script&lang=js"
export * from "./SetBaggagePrices.vue?vue&type=script&lang=js"
import style0 from "./SetBaggagePrices.vue?vue&type=style&index=0&id=be328918&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be328918",
  null
  
)

export default component.exports